import(/* webpackMode: "eager" */ "/home/runner/work/toronto-parks-atlas/toronto-parks-atlas/node_modules/next/dist/client/app-dir/link.js");
